<template>
  <AppDialog
    append-to-body
    show
    class="keep-current-plan-dialog"
    title="Special offer: Lock in your current rate"
    @close="close"
  >
    <div class="d-flex justify-content-center">
      <img :src="KEEP_CURRENT_PLAN_ILLUSTRATION" />
    </div>

    <p class="keep-current-plan-dialog-description">
      Switch to quarterly or yearly billing and <b>lock in your current rate for the next year</b>. This will keep you
      on your existing plan and guarantee no price changes as long as you’re on one of these billing periods.
    </p>

    <div class="keep-current-plan-dialog-buttons">
      <AppButton
        v-if="quarterlyPlan"
        type="primary"
        :disabled="switchingPlan"
        @click="switchBillingPeriod(quarterlyPlan, quarterlySignature)"
      >
        {{ quarterlyPlanButtonText }}
      </AppButton>

      <AppButton
        v-if="yearlyPlan"
        type="primary"
        :disabled="switchingPlan"
        @click="switchBillingPeriod(yearlyPlan, yearlySignature)"
      >
        {{ yearlyPlanButtonText }}
      </AppButton>
    </div>

    <div
      class="keep-current-plan-dialog-cancel-link"
      @click="cancel"
    >
      {{ cancelButtonText }}
    </div>
  </AppDialog>
</template>

<script>
import { OrganizationsResource } from '~/resources';
import { KEEP_CURRENT_PLAN_ILLUSTRATION } from '~/rails_assets';

export default {
  name: 'KeepCurrentPlanDialog',
  props: {
    organizationId: { type: Number, required: true },
    cancelButtonText: { type: String, required: true },
    yearlyPlan: { type: String, required: true, default: null },
    quarterlyPlan: { type: String, required: true, default: null },
    yearlySignature: { type: String, required: true, default: null },
    quarterlySignature: { type: String, required: true, default: null },
  },
  data: () => ({
    KEEP_CURRENT_PLAN_ILLUSTRATION,
    switchingPlan: null,
  }),
  computed: {
    quarterlyPlanButtonText() {
      return this.switchingPlan === this.quarterlyPlan ? 'Switching...' : 'Switch to quarterly billing';
    },
    yearlyPlanButtonText() {
      return this.switchingPlan === this.yearlyPlan ? 'Switching...' : 'Switch to yearly billing';
    },
  },
  mounted() {
    OrganizationsResource.recordAttemptCancelation({ id: this.organizationId });
  },
  methods: {
    close() {
      this.$emit('close');
    },
    cancel() {
      this.$emit('onCancel');
    },
    switchBillingPeriod(plan, signature) {
      this.switchingPlan = plan;
      const data = { change_product: false, keep_legacy_plan: true, plan, signature };

      OrganizationsResource.updatePlan({ id: this.organizationId }, data).finally(() => window.location.reload());
    },
  },
};
</script>
